import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex mb-10 w-full justify-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "nes-container with-title mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Farm Details", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Choose farm:", -1)
const _hoisted_9 = { class: "nes-select mb-5" }
const _hoisted_10 = {
  key: 2,
  class: "text-center"
}
const _hoisted_11 = {
  key: 3,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_TestMint = _resolveComponent("TestMint")!
  const _component_InitFarm = _resolveComponent("InitFarm")!
  const _component_FarmDisplay = _resolveComponent("FarmDisplay")!
  const _component_UpdateFarm = _resolveComponent("UpdateFarm")!
  const _component_TheWhitelist = _resolveComponent("TheWhitelist")!
  const _component_AuthorizeFunder = _resolveComponent("AuthorizeFunder")!
  const _component_FundCancelLock = _resolveComponent("FundCancelLock")!
  const _component_RefreshFarmer = _resolveComponent("RefreshFarmer")!
  const _component_TreasuryPayout = _resolveComponent("TreasuryPayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigPane),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Pls connect (burner) wallet"))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "nes-btn is-primary mr-5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewFarm = !_ctx.showNewFarm))
            }, " New farm "),
            _createElementVNode("button", {
              class: "nes-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshFarms && _ctx.refreshFarms(...args)))
            }, "Refetch farms")
          ]),
          (_ctx.showNewFarm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_TestMint, { class: "mb-10" }),
                _createVNode(_component_InitFarm, {
                  class: "mb-10",
                  onNewFarm: _ctx.handleNewFarm
                }, null, 8, ["onNewFarm"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.foundFarms && _ctx.foundFarms.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.farm) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foundFarms, (f) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: f.publicKey.toBase58()
                        }, _toDisplayString(f.publicKey.toBase58()), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.farm]
                    ])
                  ]),
                  _createVNode(_component_FarmDisplay, {
                    key: _ctx.farmAcc,
                    farmAcc: _ctx.farmAcc
                  }, null, 8, ["farmAcc"])
                ]),
                _createVNode(_component_UpdateFarm, {
                  farm: _ctx.farm,
                  onUpdateFarm: _ctx.handleUpdateFarm,
                  class: "mb-10"
                }, null, 8, ["farm", "onUpdateFarm"]),
                _createVNode(_component_TheWhitelist, {
                  key: _ctx.farmAcc.bank,
                  farm: _ctx.farm,
                  bank: _ctx.farmAcc.bank.toBase58(),
                  class: "mb-10"
                }, null, 8, ["farm", "bank"]),
                _createVNode(_component_AuthorizeFunder, {
                  key: _ctx.farm,
                  farm: _ctx.farm,
                  class: "mb-10"
                }, null, 8, ["farm"]),
                _createVNode(_component_FundCancelLock, {
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  class: "mb-10",
                  onUpdateFarm: _ctx.handleUpdateFarm
                }, null, 8, ["farm", "farmAcc", "onUpdateFarm"]),
                _createVNode(_component_RefreshFarmer, {
                  farm: _ctx.farm,
                  class: "mb-10"
                }, null, 8, ["farm"]),
                _createVNode(_component_TreasuryPayout, {
                  key: _ctx.farmAcc,
                  farm: _ctx.farm,
                  class: "mb-10"
                }, null, 8, ["farm"])
              ]))
            : (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Loading..."))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, "No farms found :( Start a new one?"))
        ]))
  ], 64))
}